module.exports = __webpack_public_path__ + "img/image-3.a85bf2f7.jpg";